import createVIEmojiPlugin from "./createVIEmojiPlugin";

export default createVIEmojiPlugin;
